export const SummaryConstants = {
    DEBUG: 'DEBUG',
    CurrentStep: 'CurrentStep',
	PreviousStep: 'PreviousStep',

	Current360Rotation: 'Current360Rotation',
    SelectedExteriorColour: 'selectedExteriorColour',
    SelectedInteriorColour: 'selectedInteriorColour',
    SelectedColourExteriorIndex: 'SelectedColourExteriorIndex',
    SelectedColourInteriorIndex: 'SelectedColourInteriorIndex',

    EngineAndDrivetrain: 'EngineAndDrivetrain',
    SelectedModelIndex: 'SelectedModelIndex',
    Packages: 'Packages',

    Wheels: 'Wheels',
    SelectedWheel: 'selectedWheel',
    SelectedWheelIndex: 'SelectedWheelIndex',
    SelectedAccessories: 'selectedAccessories',
    SelectedWheelSize: 'SelectedWheelSize',
    Accessories: 'Accessories',

    Colours: 'Colours',
    DefaultExteriorColour: 'defaultExteriorColour',
    DefaultInteriorColour: 'defaultInteriorColour',

    AllowedColoursExterior: 'AllowedColoursExterior',

    SelectedModelYear: 'selectedModelYear',
    SelectedTrim: 'selectedTrim',
    SelectedTrimIndex: 'selectedTrimIndex',
    FinancialObj: 'financialObj',
    SelectedModel: 'selectedModel',
    VehicleTitle: 'vehicleTitle',

    SelectedPackage: 'selectedPackage',
    SelectedNonModelPackage: 'selectedNonModelPackage',
    SelectedWarrantyPackage: 'selectedWarrantyPackage',
    SelectedConnectedVehiclePackage: 'selectedConnectedVehiclePackage',
    SelectedAddedProtectionPackage: 'selectedAddedProtectionPackage',
    SelectedAppearanceProtectionPackage: 'selectedAppearanceProtectionPackage',
    SelectedAppearanceProtectionPlansPackage: 'selectedAppearanceProtectionPlansPackage',

    SelectedPackageIndex: 'selectedPackageIndex',
    SelectedNonModelPackageIndex: 'selectedNonModelPackageIndex',
    SelectedWarrantyIndex: 'selectedWarrantyIndex',
    SelectedConnectedVehicleIndex: 'selectedConnectedVehicleIndex',
    SelectedAddedProtectionIndex: 'selectedAddedProtectionIndex',
    SelectedAppearanceProtectionIndex: 'selectedAppearanceProtectionIndex',
    SelectedAppearanceProtectionPlanPackageIndex: 'selectedAppearanceProtectionPlanPackageIndex',

    IncludeFees: 'includeFees',
    IncludeRebates: 'includeRebates',
    IncludeTaxes: 'includeTaxes',

    ShowFinancePrice: 'showFinancePrice',

    UrlSlugObjectTrims: 'urlSlugObjectTrims',
    UrlSlugObjectEngineAndDrivetrain: 'urlSlugObjectEngineAndDrivetrain',
    UrlSlugObjectPackage: 'urlSlugObjectPackage',
    UrlSlugObjectColour: 'urlSlugObjectColour',
    UrlSlugObjectWheels: 'urlSlugObjectWheels',
    UrlSlugObjectAccessories: 'urlSlugObjectAccessories',
    UrlSlugObjectPayments: 'urlSlugObjectPayments',

    FinanceTermIndex: 'FinanceTermIndex',
    LeaseTermIndex: 'LeaseTermIndex',
    FinanceTerm: 'FinanceTerm',
    LeaseTerm: 'LeaseTerm',


    LoyaltyChecked: 'LoyaltyChecked',
    GraduateChecked: 'GraduateChecked',
    MilitaryChecked: 'MilitaryChecked',
    FirstTimeOwnerChecked: 'FirstTimeOwnerChecked',

    TradeInValue: 'TradeInValue',
    DownPaymentValue: 'DownPaymentValue',
    
    LegalVehicles: 'LegalVehicles',
    LegalTrims: 'LegalTrims',
    LegalEngineAndDrivetrain: 'LegalEngineAndDrivetrain',
    LegalOption: 'LegalOption',
    LegalPackage: 'LegalPackage',
    LegalConnectivity: 'LegalConnectivity',
    LegalColours: 'LegalColours',
    LegalWheels: 'LegalWheels',
    LegalAccessories: 'LegalAccessories',
    LegalProtections: 'LegalProtections',
    LegalPaymentInformation: 'LegalPaymentInformation',
    LegalSummary: 'LegalSummary',
    SpecificationData: 'SpecificationData',

    InitialFinance: 'InitialFinance',
    SelectedVehicle: 'SelectedVehicle',
    AvailableTrim: 'AvailableTrim',

    PPSA: 'PPSA',
    AllDataIsLoaded: 'AllDataIsLoaded',

    HasFinancialProviderError: 'HasFinancialProviderError',
    AnnualMileage : 'AnnualMileage'
}